module.exports = __webpack_public_path__ + "Roboto-BoldItalic.woff?563c4bd6da24f5ce46e7aee2aace04f9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BoldItalic/Roboto-BoldItalic.woff?v=2.137
// module id = 192
// module chunks = 7